import "../../sass/layout/wellness-badge/wellnessbadge.css"

export const WellnessEventBadge = ({ text }) => {
	if(!text) return null;
	return (
		<div className="wellness-badge">
			<span className="wellness-badge-text">{text}</span>
		</div>
	);
}